import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const StyledMuiSelect = styled('div')(({ theme }) => ({
  fontFamily: 'ProductSansRegular, sans-serif',
  fontSize: '16px',
  width: '100%',
  '.react-select__control': {
    borderColor: theme.palette.grey[400],
    height: '56px',
    borderRadius: '1px',
    boxShadow: 'none',
    '&:hover': {
      borderColor: theme.palette.grey[600],
    },
    '&--is-focused': {
      borderColor: theme.palette.primary.main,
    },
  },
  '.react-select__value-container': {
    padding: '0 16px',
  },
  '.react-select__placeholder': {
    color: theme.palette.grey[500],
  },
  '.react-select__single-value': {
    color: theme.palette.text.primary,
  },
  '.react-select__indicator': {
    color: theme.palette.grey[500],
  },
  '.react-select__menu': {
    borderRadius: '1px',
    boxShadow: theme.shadows[3],
    zIndex: 1300,
  },
  '.react-select__option': {
    padding: '10px',
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
    '&--is-focused': {
      backgroundColor: theme.palette.action.selected,
    },
  },
}));

export const MuiSelect = ({
  value, onChange, name, placeholder, options, isDisabled,
}) => {
  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

  return (
    <StyledMuiSelect>
      <Select
        name={name}
        value={value}
        onChange={handleChange}
        options={options}
        isDisabled={isDisabled}
        placeholder={placeholder}
        classNamePrefix="react-select"
      />
    </StyledMuiSelect>
  );
};

MuiSelect.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      label: PropTypes.string,
    }),
  ]).isRequired,
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  isDisabled: PropTypes.bool,
};

MuiSelect.defaultProps = {
  placeholder: '',
  options: [],
  isDisabled: false,
};

const RenderMuiSelect = ({
  input, meta, options, placeholder, isDisabled,
}) => (
  <div style={{ width: '90%' }}>
    <MuiSelect
      {...input}
      options={options}
      placeholder={placeholder}
      isDisabled={isDisabled}
    />
    {meta.touched && meta.error && (
      <span style={{ color: 'red', fontSize: '12px' }}>{meta.error}</span>
    )}
  </div>
);

RenderMuiSelect.propTypes = {
  input: PropTypes.shape({
    onChange: PropTypes.func,
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    name: PropTypes.string,
  }).isRequired,
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  options: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })),
  placeholder: PropTypes.string,
  isDisabled: PropTypes.bool,
};

RenderMuiSelect.defaultProps = {
  meta: null,
  options: [],
  placeholder: '',
  isDisabled: false,
};

export default RenderMuiSelect;
